const SDK_VERSION = '7.49.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
